export default __webpack_public_path__ + "static/media/1_Tienda online_1636x1341.26c40862.png";